// Module
var code = "<div class=\"tw-text-center\">\n    <h1 class=\"tw-font-bold tw-text-4xl lg:tw-text-6xl tw-text-black tw-mb-8\">{{ $ctrl.title }}</h1>\n    <h2 class=\"tw-text-grey-darker-1 tw-text-xl lg:tw-text-2xl tw-font-normal tw-mb-8\">{{ $ctrl.subtitle }}</h2>\n</div>\n";
// Exports
module.exports = code;